import React from "react";
import PropTypes from "prop-types";

/**
 * A wrapper component that isolates Tailwind CSS styles from Material-UI
 * All Tailwind CSS classes should be used within components wrapped by this component
 */
const TailwindWrapper = ({ children, className = "" }) => {
  return (
    <div id="tailwind-root" data-testid="tailwind-root" className={className}>
      {children}
    </div>
  );
};

TailwindWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default TailwindWrapper;
